import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";
import MUIDataTable, {
  MUIDataTableColumnDef,
  MUIDataTableOptions,
} from "mui-datatables";

import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router";
import EllipsisText from "../../../../common/elements/EllipsisText";
import { getDescription } from "./components/DiamondTableComponents";
import { convertedPrebidValue, convertedValue } from "../TenderGenericFunc";
import {
  getAbbreviation,
  makeLinkClickable,
  openCertificateLinkPopup,
} from "../../../../common/GenericFunctions";
import AlertReadOnlyUser from "../../../../common/elements/AlertReadOnlyUser";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Menu, MenuItem, IconButton } from "@material-ui/core";
import { useSelector } from "react-redux";
import {
  selecLiveCurrentApiStartCount,
  selectLiveItemPerPage,
} from "../../../../redux/slice/commanPagination/commanPaginationSlice";
import { RootState } from "../../../../redux/reducer";
import CustomFooter from "../../../365Auction/component/CustomFooter";
import PreviewPrebiding from "../bulkWatchlistComponent/PreviewPrebiding";

import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import Alert from "../../../../common/elements/Alert";
const faHeartProps = faHeart as IconProp;

const StyledLayoutGrid = styled(Grid)`
  .MuiPaper-root {
    width: 100%;
  }
  .MuiTableCell-head {
    padding: 10px 5px !important;
    white-space: nowrap;
  }
    
  .MuiTableCell-root {
    padding: 14px;
    border: 1px solid lightgray;
    
  }
  .MuiToolbar-regular {
    min-height: 0px;
  }
  .MuiTableCell-head {
    background: ${(props) => props.theme.colors.base.buttonGradientFirstColor};
    color: white;
    text-align: center;
    font-weight: 700;
    border: 1px solid lightgray;
  }

  .MuiTableCell-root {
    text-align: center;
    background: ${(props) => props.theme.colors.base.tableRowBackground};
    max-width: 100px;
  }

  .MuiTableCell-head .MuiButton-root {
    color: white;
    text-align: center;
    font-weight: 700;
  }

  .linkCss {
    text-decoration: underline;
    color: blue;
    cursor: pointer;
  }

  .MuiTableCell-footer {
    padding: 1px;
  }

  .MuiIconButton-edgeEnd {
    display: contents !important;
    transition: width 5s !important;
  }
  .MuiAccordionSummary-root {
    min-height: 10px !important;
    transition: width 4s !important;
  }
  .MuiPaper-root {
    box-shadow: none !important;
  }
`;

const StyledTextWrapper = styled(Grid)`
  margin: auto;
  text-align: center;
`;
const StyledCoreDataGridContainer = styled(Grid)``;

export const StyledButtonView = styled.button`
  color: ${(props) => props.theme.colors.base.grey};
  font-size: 0.9em;
  padding: 0.4em;
  margin: 0.3em;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.base.lightGrey};
  background: ${(props) => props.theme.colors.base.veryVeryLightGrey};
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.base.textColor};
    cursor: pointer;
  }

  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    font-size: 0.8em;
  }
`;

export const StyledCloseicon = styled.img`
  height: 1.4em;
  width: 1.4em;
  &:hover {
    cursor: pointer;
  }
`;

export const Styledview = styled.img`
  height: 1em;
  width: 1em;
  &:hover {
    cursor: pointer;
  }
`;

let auctioneerSellerUserId: any = "";
let sourceFromUrl: any;

const columnIndexes = {
  serialNo: 0,
  productId: 1,
  auctionUserId: 2,
  productCode: 4,
  lab: 5,
  certificate: 6,
  description: 7,
  productDescription: 8,
  carat: 9,
  color: 10,
  clarity: 11,
  remarks: 12,
  noOfPieces: 13,
  shape: 14,
  sieve: 15,
  cutGrade: 16,
  polish: 17,
  symmetryAbbreviation: 18,
  flour: 19,
  currency: 20,
  peicePerCt: 21,
  notes: 22,
  repnetPrice: 23,
  rowColor: 24,
  exchangeRate: 25,
  parcelType: 26,
  watched: 27,
  rapnetPercentage: 28,
  sellerAuctionUserId: 29,
  preBidPrice: 31,
  shapeAbbreviation: 32,
  polishAbbreviation: 33,
  flourAbbreviation: 34,
  colorValue: 35,
};

interface IProps {
  products?: any;
  auctionName: string;
  watchlist: any;
  auctionDate: any;
  removeFromWatchlist: any;
  auctionId: string;
  dataSort: (val: any, ordr: any) => void;
  getUpdateData: (start: any, end: any) => void;
  totalElements: any;
  itemPerPageForTable: any;
  endCount: any;
  page: any;
  setexportIds: any;
  selectedExportId: any;
  prebidCall: any;
}
let currentPageNumber = 0;
let isReadOnlyUser: any;
let isSellerAuctionUserId: any;

const initialState = {
  mouseX: null,
  mouseY: null,
};

const TableContainer = (props: IProps) => {
  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MUIDataTableSelectCell: {
          fixedHeader: {
            background: "white",
          },
          fixedLeft: {
            background: "white",
          },
        },
      },
    });
  const {
    products,
    removeFromWatchlist,
    watchlist,
    getUpdateData,
    totalElements,
    auctionId,
    selectedExportId,
    prebidCall,
  } = props;

  const [auctionProducts, setAuctionProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isAuctionUserId, setIsAuctionUserId] = useState(false);
  const [openReadOnlyUserToast, setOpenReadOnlyUserToast] = useState(false);
  const [currentProductId, setCurrentProductId] = useState<string>("");
  const [isSort, setIsSort] = useState<boolean>(false);
  const [openToast, setOpenToast] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");

  const [mouseState, setMouseState] = React.useState<{
    mouseX: null | number;
    mouseY: null | number;
  }>(initialState);
  const { t } = useTranslation();
  const history = useHistory();

  const selectcurrentApiStartCountValue: any = useSelector((state: RootState) =>
    selecLiveCurrentApiStartCount(state)
  );

  const selectItemPerPageValue: any = useSelector((state: RootState) =>
    selectLiveItemPerPage(state)
  );

  useEffect(() => {
    PubSub.subscribe("pageNumber", (msg: any, data: any) => {
      currentPageNumber = data - 1;
    });

    setAuctionProducts(products);
    setIsLoading(true);
    var joinedAuctions: any = localStorage.getItem("joinedAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);

    if (joinedAuctions !== null) {
      joinedAuctions.filter((items: any) => {
        if (items.perId === auctionId) {
          auctioneerSellerUserId = items.auctionUserId;
        }
        if (auctioneerSellerUserId === items.auctionUserId) {
          setIsAuctionUserId(true);
        }
      });
    } else {
      setIsAuctionUserId(false);
    }
    isReadOnlyUser = localStorage.getItem("isReadOnlyUser");
    isReadOnlyUser = JSON.parse(isReadOnlyUser);

    return () => {
      localStorage.removeItem("pathname");
      setIsAuctionUserId(false);
      localStorage.removeItem("auctioneerUserId");
    };
  }, []);

  const getTableBodyHeight = () => {
    var h = window.innerHeight;
    let heightOfInnerTable = h - 250;
    if (products.length > 7) {
      return `${heightOfInnerTable}px`;
    } else {
      return `auto`;
    }
  };

  const renderReadOnlyUserToast = async (id: any) => {
    var joinedAuctions: any = localStorage.getItem("joinedAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);
    if (joinedAuctions !== null) {
      joinedAuctions.filter((items: any) => {
        if (id === items.auctionUserId) {
          isSellerAuctionUserId = true;
        }
      });
    } else {
      isSellerAuctionUserId = false;
    }
    await renderPopup();
  };

  const renderPopup = () => {
    if (isReadOnlyUser) {
      setOpenReadOnlyUserToast(true);
    } else if (isSellerAuctionUserId) {
      setOpenReadOnlyUserToast(true);
    } else {
      setOpenReadOnlyUserToast(false);
    }
    setTimeout(() => {
      setOpenReadOnlyUserToast(false);
    }, 3000);
  };

  const rightClickEvent = (
    event: React.MouseEvent<HTMLDivElement>,
    productId: string
  ) => {
    event.preventDefault();
    setMouseState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
    setCurrentProductId(productId);
  };

  const handleClose = () => {
    setMouseState(initialState);
  };

  const diamondColumns: MUIDataTableColumnDef[] = [
    {
      name: "serialNo",
      label: `${t("common:Tender:tableColumnNames:serialNo")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
      },
    },
    {
      name: "perId",
      label: "Product Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "auctionUserId",
      label: "Auction User Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "",
      label: `${t("common:Tender:tableColumnNames:ActionsTender")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          let isClickableRemark: any;
          if (tableMeta.rowData[columnIndexes.parcelType] === "Parcel") {
            isClickableRemark = makeLinkClickable(
              tableMeta.rowData[columnIndexes.productDescription]
            );
          } else {
            isClickableRemark = makeLinkClickable(
              tableMeta.rowData[columnIndexes.remarks]
            );
          }
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                cursor: "pointer",
                alignItems: "center",
                gap: "5px",
              }}
              title={`Add Product into Wishlist`}
            >
              {isReadOnlyUser ? (
                <FontAwesomeIcon
                  icon={faHeartProps}
                  style={{ color: "gray" }}
                  onClick={() => {
                    renderReadOnlyUserToast(
                      tableMeta.rowData[columnIndexes.sellerAuctionUserId]
                    );
                  }}
                />
              ) : (
                <>
                  {isAuctionUserId ? (
                    <div>
                      {tableMeta.rowData[columnIndexes.sellerAuctionUserId] !==
                        auctioneerSellerUserId ? (
                        <>
                          {getWatchedProduct(
                            tableMeta.rowData[columnIndexes.watched],
                            tableMeta.rowData[columnIndexes.productId],
                            props.auctionId,
                            tableMeta.rowData[1],
                            removeFromWatchlist,
                            watchlist
                          )}
                        </>
                      ) : (
                        <FontAwesomeIcon
                          icon={faHeartProps}
                          style={{ color: "gray" }}
                          onClick={() => {
                            renderReadOnlyUserToast(
                              tableMeta.rowData[
                              columnIndexes.sellerAuctionUserId
                              ]
                            );
                          }}
                        />
                      )}
                    </div>
                  ) : (
                    <FontAwesomeIcon
                      icon={faHeartProps}
                      style={{ color: "gray" }}
                      onClick={() => {
                        renderReadOnlyUserToast(
                          tableMeta.rowData[columnIndexes.sellerAuctionUserId]
                        );
                      }}
                    />
                  )}{" "}
                </>
              )}
              <>
                {isClickableRemark !== false && (
                  <span
                    title="Video Link"
                    style={{ color: "balck", cursor: "pointer" }}
                    onClick={() => {
                      window.open(
                        isClickableRemark,
                        "DescriptiveWindowName",
                        "height=700px,width=1024px,scrollbars,toolbar,status,resizable"
                      );
                    }}
                  >
                    <PlayCircleOutlineIcon style={{ width: "0.8em" }} />
                  </span>
                )}
              </>
            </div>
          );
        },
      },
    },
    {
      name: "code",
      label: `${t("common:Tender:tableColumnNames:Itemcode")}`,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { minWidth: "150px", maxWidth: "150px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <span
              className="linkCss"
              onClick={() =>
                openProductDetail(
                  props.auctionId,
                  tableMeta.rowData[1],
                  props.auctionDate
                )
              }
              onContextMenu={(event: any) =>
                rightClickEvent(event, tableMeta.rowData[1])
              }
            >
              {value}
            </span>
          );
        },
      },
    },
    {
      name: "lab",
      label: `${t("common:Tender:tableColumnNames:lab")}`,
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: any, tableMeta: any) => {
          if (
            value !== "AGT" &&
            value !== "agt" &&
            value !== "" &&
            value !== undefined
          ) {
            return (
              <span
                className="linkCss"
                onClick={() =>
                  openCertificateLinkPopup(
                    value,
                    tableMeta.rowData[columnIndexes.certificate]
                  )
                }
              >
                {value}
              </span>
            );
          } else {
            return <span>{value}</span>;
          }
        },
      },
    },
    {
      name: "certificate",
      label: `${t("common:Tender:tableColumnNames:certification")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "description",
      label: `${t("common:Tender:tableColumnNames:description")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "productDescription",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },

    {
      name: "carat",
      label: `${t("common:Tender:tableColumnNames:carat")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
      },
    },
    {
      name: "color",
      label: `${t("common:Tender:tableColumnNames:color")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              <EllipsisText
                text={getAbbreviation(
                  tableMeta.rowData[columnIndexes.colorValue]
                )}
                length={12}
                tail={"..."}
              />
            </>
          );
        },
      },
    },
    {
      name: "clarity",
      label: `${t("common:Tender:tableColumnNames:clarity")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return <EllipsisText text={value} length={12} tail={"..."} />;
        },
      },
    },
    {
      name: "remarks",
      label: `${t("common:Tender:tableColumnNames:remark")}`,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { minWidth: "160px", maxWidth: "160px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          let isClickableRemark: any;
          if (tableMeta.rowData[columnIndexes.parcelType] === "Parcel") {
            isClickableRemark = makeLinkClickable(
              tableMeta.rowData[columnIndexes.productDescription]
            );
          } else {
            isClickableRemark = makeLinkClickable(
              tableMeta.rowData[columnIndexes.remarks]
            );
          }
          return (
            <>
              {isClickableRemark !== false ? (
                <span
                  style={{ color: "blue", cursor: "pointer" }}
                  onClick={() => {
                    window.open(
                      isClickableRemark,
                      "DescriptiveWindowName",
                      "height=700px,width=1024px,scrollbars,toolbar,status,resizable"
                    );
                  }}
                >
                  <EllipsisText
                    text={getDescription(
                      tableMeta.rowData[columnIndexes.parcelType],
                      tableMeta.rowData[columnIndexes.productDescription],
                      tableMeta.rowData[columnIndexes.remarks]
                    )}
                    length={20}
                    tail={"..."}
                  />
                </span>
              ) : (
                <EllipsisText
                  text={getDescription(
                    tableMeta.rowData[columnIndexes.parcelType],
                    tableMeta.rowData[columnIndexes.productDescription],
                    tableMeta.rowData[columnIndexes.remarks]
                  )}
                  length={20}
                  tail={"..."}
                />
              )}
            </>
          );
        },
      },
    },
    {
      name: "noOfPieces",
      label: `${t("common:Tender:tableColumnNames:noOfPieces")}`,
      options: {
        filter: false,
        sort: false,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return <>{value !== 0 ? value : "-"}</>;
        },
      },
    },
    {
      name: "shape",
      label: `${t("common:Tender:tableColumnNames:shape")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              <EllipsisText
                text={getAbbreviation(
                  tableMeta.rowData[columnIndexes.shapeAbbreviation]
                )}
                length={12}
                tail={"..."}
              />
            </>
          );
        },
      },
    },
    {
      name: "sieve",
      label: `${t("common:Tender:tableColumnNames:Sieve")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        setCellProps: () => ({
          style: { minWidth: "160px", maxWidth: "160px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          return <>{value !== "-" ? value : ""}</>;
        },
      },
    },
    {
      name: "cutGrade",
      label: `${t("common:Tender:tableColumnNames:cutGrade")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              <EllipsisText
                text={getAbbreviation(value)}
                length={12}
                tail={"..."}
              />
            </>
          );
        },
      },
    },
    {
      name: "polish",
      label: `${t("common:Tender:tableColumnNames:polish")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              {getAbbreviation(
                tableMeta.rowData[columnIndexes.polishAbbreviation]
              )}
            </>
          );
        },
      },
    },
    {
      name: "symmetryAbbreviation",
      label: `${t("common:Tender:tableColumnNames:symmetryAbbreviation")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return <>{getAbbreviation(value)}</>;
        },
      },
    },
    {
      name: "flour",
      label: `${t("common:Tender:tableColumnNames:flour")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              {getAbbreviation(
                tableMeta.rowData[columnIndexes.flourAbbreviation]
              )}
            </>
          );
        },
      },
    },
    {
      name: "currency",
      label: "currency",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "caratMinimumPrice",
      label: `${t("common:Tender:tableColumnNames:pricePct")}`,
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({
          style: { minWidth: "160px", maxWidth: "160px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div
              style={{
                textAlign: "center",
              }}
            >
              {value !== 0 || value !== null || value !== undefined
                ? convertedValue(
                  tableMeta.rowData[columnIndexes.currency],
                  value,
                  tableMeta.rowData[columnIndexes.exchangeRate][0].rate
                )
                : "-"}
            </div>
          );
        },
      },
    },
    {
      name: "notes",
      label: `${t("common:Tender:tableColumnNames:notes")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "rapnetPercentage",
      label: `${t("common:Tender:tableColumnNames:rapOff")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div
              style={{
                display: "flex",
                gridGap: "10px",
                justifyContent: "center",
              }}
            >
              {getRapNet(tableMeta.rowData[columnIndexes.rapnetPercentage])}
            </div>
          );
        },
      },
    },
    {
      name: "rowColor",
      label: "Bid Color",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "exchangeRates",
      label: "Exchange Rate",
      options: {
        display: false,
      },
    },
    {
      name: "parcelType",
      label: "",
      options: {
        display: false,
      },
    },
    {
      name: "watched",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "rapnetPercentage",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "sellerAuctionUserId",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "yourbid",
      label: `${t("common:Tender:tableColumnNames:placeBid")}`,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { minWidth: "160px", maxWidth: "160px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div
              style={{
                textAlign: "center",
              }}
            >
              {getPreBidPrice(products[tableMeta.rowIndex])}
            </div>
          );
        },
      },
    },
    {
      name: "preBidPrice",
      label: `${t("common:Tender:tableColumnNames:yourBids")}`,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { minWidth: "160px", maxWidth: "160px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div
              style={{
                textAlign: "center",
              }}
            >
              {value !== 0 || value !== null || value !== undefined
                ? convertedPrebidValue(
                  tableMeta.rowData[columnIndexes.currency],
                  value ?? 0,
                  tableMeta.rowData[columnIndexes.exchangeRate][0].rate
                )
                : "-"}
            </div>
          );
        },
      },
    },
    {
      name: "shapeAbbreviation",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "polishAbbreviation",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "flourAbbreviation",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "colorValue",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
  ];

  const getRapNet = (rapnetPercentage: any) => {
    if (rapnetPercentage === undefined || rapnetPercentage === 0) {
      return `-`;
    } else {
      return rapnetPercentage;
    }
  };

  const getPreBidPrice = (items: any) => {
    return (
      <PreviewPrebiding
        {...props}
        items={items}
        count={0}
        apiCall={prebidCall}
        isReadOnlyUser={isReadOnlyUser}
        isMobileUi={false}
      />
    );
  };

  const getWatchedProduct = (
    watched: any,
    productId: any,
    auctionId: any,
    serialNo: any,
    removeFromWatchlist: any,
    addToWatchList: any
  ) => {
    if (watched === true) {
      return (
        <FontAwesomeIcon
          icon={faHeartProps}
          style={{ color: "red", cursor: "pointer" }}
          onClick={() => removeFromWatchlist(productId, auctionId)}
        />
      );
    } else {
      return (
        <FontAwesomeIcon
          icon={faHeartProps}
          style={{ color: "gray" }}
          onClick={() => addToWatchList(productId, auctionId, serialNo)}
        />
      );
    }
  };

  const openProductDetail = (
    auctionId: string,
    perId: string,
    auctionDate: string
  ) => {
    const urlParams = new URLSearchParams(window.location.search);
    sourceFromUrl = urlParams.get("source");
    if (sourceFromUrl === "admin") {
      history.push(
        `/preview/details/${auctionId}/${perId}/${auctionDate}?redirectFromPreview=true`
      );
    } else {
      history.push(`/preview/details/${auctionId}/${perId}/${auctionDate}`);
    }
  };

  const openDetailsView = (
    auctionId: string,
    perId: string,
    auctionDate: string
  ) => {
    const language = localStorage.getItem("language");

    const languageCode =
      language === "EN" ? "en" : language === "zh_CN" ? "zh_CN" : "jp";

    if (sourceFromUrl === "admin") {
      window.open(
        `/${languageCode}/preview/details/${auctionId}/${perId}/${auctionDate}?redirectFromPreview=true`,
        "_blank"
      );
    } else {
      window.open(
        `/${languageCode}/preview/details/${auctionId}/${perId}/${auctionDate}`,
        "_blank"
      );
    }
  };

  const options: MUIDataTableOptions = {
    filter: false,
    download: "false",
    print: "false",
    viewColumns: "false",
    selectableRows: "multiple",
    selectableRowsHeader: true,
    selectableRowsOnClick: false,
    rowsSelected: selectedExportId,
    selectableRowsHideCheckboxes: false,
    count: totalElements,
    serverSide: true,
    search: false,
    rowsPerPage: selectItemPerPageValue,
    rowsPerPageOptions: [0],
    sort: true,
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      return (
        <div className="mailIconDiv">
          <IconButton color="primary">
            <i className="zmdi zmdi-email"></i>
          </IconButton>
        </div>
      );
    },
    page: selectcurrentApiStartCountValue,
    onChangePage: (currentPage: number) => {
      currentPageNumber = currentPage;
      getUpdateData(
        currentPage * selectItemPerPageValue,
        selectItemPerPageValue
      );
      localStorage.setItem(
        "currentStart",
        JSON.stringify(currentPage * selectItemPerPageValue)
      );
    },
    customFooter: (
      count,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage,
      textLabels
    ) => {
      return (
        <CustomFooter
          count={count}
          page={page}
          rowsPerPage={rowsPerPage}
          changeRowsPerPage={changeRowsPerPage}
          changePage={changePage}
          textLabels={textLabels}
        />
      );
    },
    onSearchChange: () => {
      //
    },
    setRowProps: () => {
      return { style: { background: "white" } };
    },
    onColumnSortChange: (price, direction) => {
      let order = "";
      if (isSort === false) {
        order = "desc";
      } else {
        order = "asc";
      }
      setIsSort(!isSort);
      props.dataSort(price, order);
    },
    onRowSelectionChange: (
      currentRowsSelected: any,
      allRowsSelected: any,
      rowsSelected: any
    ) => {
      if (!isSellerAuctionUserId || !isReadOnlyUser) {
        props.setexportIds(rowsSelected.slice(0, 10));

        if (rowsSelected.length > 10) {
          setShowAlertMessage(
            `${t("common:Tender:validation:productSelection")}`
          );
          setAlertType("error");
          setOpenToast(true);
        }
      }
    },
    tableBodyHeight: getTableBodyHeight(),
    isRowSelectable: (dataIndex: any, selectedRows: any) => {
      const disableRowIndexsArray = getDisableRowIndex();
      return disableRowIndexsArray.includes(dataIndex) ? false : true;
    },
  };

  const getDisableRowIndex = () => {
    return auctionProducts.map((items: any, index: number) => {
      if (isReadOnlyUser) {
        return index;
      } else {
        if (auctioneerSellerUserId === items.sellerAuctionUserId) {
          return index;
        }
      }
    });
  };

  return (
    <StyledLayoutGrid container={true}>
      {products.length > 0 ? (
        <>
          <StyledCoreDataGridContainer container={true} spacing={0}>
            <MuiThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                title={""}
                data={products}
                columns={diamondColumns}
                options={options}
              />
            </MuiThemeProvider>
          </StyledCoreDataGridContainer>
        </>
      ) : (
        <Grid container={true} spacing={0}>
          <StyledTextWrapper item xs={12}>
            {t("common:preview:noProductFound")}
          </StyledTextWrapper>
        </Grid>
      )}
      <Menu
        keepMounted
        open={mouseState.mouseY !== null}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          mouseState.mouseY !== null && mouseState.mouseX !== null
            ? { top: mouseState.mouseY, left: mouseState.mouseX }
            : undefined
        }
      >
        <MenuItem
          onClick={() =>
            openDetailsView(
              props.auctionId,
              currentProductId,
              props.auctionDate
            )
          }
        >
          Details
        </MenuItem>
      </Menu>
      {openReadOnlyUserToast === true && (
        <AlertReadOnlyUser
          isReadOnlyUser={isReadOnlyUser}
          isSeller={isSellerAuctionUserId}
        />
      )}
      {openToast && (
        <Alert showAlertMessage={showAlertMessage} alertType={alertType} />
      )}
    </StyledLayoutGrid>
  );
};

export default TableContainer;
